export default function loadFont(name: string, urls: string[], id: string) {
    const parent = document.getElementById(id)!
    loadFontToElement(name, urls, parent)
};

export function loadFontToElement(name: string, urls: string[], element: HTMLElement) {
    const fontFaceRule = `
            @font-face {
                font-display: swap;
                font-family: '${name}';
                src: ${urls
        .map((url) => `url('${url}') format('${getFontFormat(url)}')`)
        .join(", ")};
            }
        `;

    const styleElement = document.createElement("style");
    styleElement.type = "text/css";
    styleElement.appendChild(document.createTextNode(fontFaceRule));

    element.insertBefore(styleElement, element.firstChild);

    // console.log(`Font ${name} loaded with URLs:`, urls);
};

const getFontFormat = (url: string): string => {
    if (url.endsWith(".woff2")) return "woff2";
    if (url.endsWith(".woff")) return "woff";
    if (url.endsWith(".ttf")) return "truetype";
    if (url.endsWith(".otf")) return "opentype";
    return "unknown";
};